<template>
  <b-form
    class="signUp"
    @submit.prevent="submitSignUp"
    novalidate
    >
    <b-form-group
      label="E-mail:"
      label-for="signUpEmailInput"
      >
      <b-form-input
        id="signUpEmailInput"
        type="email"
        required
        placeholder="example@domain.com"
        autocomplete="on"
        v-model.trim="$v.email.$model"
        :class="{ 'is-invalid': $v.email.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.email.required">E-mail field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.email.eamil && $v.email.required">
        E-mail field must contain valid E-mail address
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Password:"
      label-for="signUpPasswordInput"
      >
      <b-form-input
        id="signUpPasswordInput"
        type="password"
        required
        autocomplete="on"
        v-model.trim="$v.password.$model"
        :class="{ 'is-invalid': $v.password.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.password.required">Password field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.password.minLength && $v.password.required">
        Password must have at least {{$v.password.$params.minLength.min}} letters
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Password confirm:"
      label-for="signinPasswordConfirmInput"
      >
      <b-form-input
        id="signinPasswordConfirmInput"
        type="password"
        required
        invalid
        autocomplete="on"
        v-model="$v.passwordConfirm.$model"
        :class="{ 'is-invalid': $v.passwordConfirm.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.passwordConfirm.sameAsPassword">
        Passwords must be identical
      </b-form-invalid-feedback>
    </b-form-group>
    <div class="oauth" v-if="isUserAnonymous">
      <a
        href="#"
        class="oauth__link"
        @click.prevent="signUpAnonymousWithGoogle"
        v-b-tooltip.hover.top
        title="Sign up with Google"
        >
        <img src="@/assets/imgs/icons/google.svg" class="oauth__img" alt="Google">
      </a>
    </div>
    <div>
      <b-button
        variant="info"
        class="authForm__submit"
        type="submit"
        :disabled="authInProgress"
        >
        Submit
      </b-button>
    </div>
  </b-form>
</template>

<script>
// modules
import { mapState } from 'vuex'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
// services
import auth from '@/services/auth'

export default {
  data () {
    return {
      email: '',
      password: '',
      passwordConfirm: ''
    }
  },
  computed: {
    ...mapState([
      'authInProgress',
      'isUserAnonymous',
      'userId'
    ])
  },
  methods: {
    submitSignUp () {
      if (this.authInProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.$store.commit('addProcess', {
        process: 'signUp',
        message: 'Sign up'
      })
      this.$store.commit('destroyCasl')

      if (this.isUserAnonymous) {
        let data = {
          email: this.email,
          password: this.password,
          uid: this.userId
        }

        auth.signUpAnonymous(data, (err) => {
          this.$store.commit('deleteProcess', 'signUp')
          if (err) this.$store.commit('addError', err.message)
          else this.$router.push('/home')
        })
      } else {
        auth.signUp(this.email, this.password, (err) => {
          this.$store.commit('deleteProcess', 'signUp')
          if (err) this.$store.commit('addError', err.message)
          else this.$router.push('/home')
        })
      }
    },
    signUpAnonymousWithGoogle () {
      this.$store.commit('addProcess', {
        process: 'signUp',
        message: 'Sign up'
      })
      this.$store.commit('destroyCasl')

      let data = {
        email: this.email,
        password: this.password,
        uid: this.userId
      }

      auth.signUpAnonymousWithGoogle(data, (err) => {
        this.$store.commit('deleteProcess', 'signUp')
        if (err) this.$store.commit('addError', err.message)
        else this.$router.push('/home')
      })
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    },
    passwordConfirm: {
      sameAsPassword: sameAs('password')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Auth/SignUp.vue